import * as Yup from "yup";

const Validation = Yup.object({
  languageId: Yup.string().required("Please select language!"),
  name: Yup.string().required("Please enter name!"),
  content: Yup.string().required("Please enter content!"),
});

export default Validation;
